// extracted by mini-css-extract-plugin
export var headlineBorderLeft = "headline-module--headline-border-left--3ChRT";